export default "__VITE_ASSET__CDrjtsx7__"